document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".js-featured-slider");
    if(!section) return;

    const slider = section.querySelector(".js-featured-slider-swiper");
    if(!slider) return;

    const swiper = new Swiper(slider, {
        navigation: {
            nextEl: '.js-featured-slider-swiper-next',
            prevEl: '.js-featured-slider-swiper-prev',
        }
    });
});